import {useMutation} from '@tanstack/react-query';
import {HTTPError} from 'ky';
import {useTranslation} from 'tolgee';

import {showNotification} from '~components/common/Notification';
import {showApiErrorNotification} from './api';
import {setUserPreferences} from './users';

export function useUserPreferencesMutation() {
  const {t} = useTranslation('settings');

  return useMutation<{landingPage: string}, HTTPError, string>({
    mutationFn: (landingPage) => setUserPreferences(landingPage),
    onSuccess: () => {
      showNotification({
        message: t('landingPageSuccess'),
        severity: 'success',
      });
    },
    onError: showApiErrorNotification,
  });
}
